import { restJson } from "./httpClient";
import type { SamplesResponse } from "../types";

const SAMPLES_PATH = "/ai/insights/samples";

export async function getSamples(): Promise<SamplesResponse> {
  const response = await restJson<SamplesResponse>(SAMPLES_PATH);
  return {
    explores: response.explores.map((group) => ({
      id: group.id,
      key: group.key,
      samples: group.samples.map((sample) => ({
        id: sample.id,
        category: sample.category,
        prompt: sample.prompt,
        key: sample.key,
      })),
    })),
  };
}
